export const nearMeKeywords = {
	'24-hour': {
		category: 'amenity',
		clpSlug: '24-hour-access',
		displayName: '24 Hour Access',
		searchParams: { amenity: '24-hour-access' },
	},
	'climate-controlled': {
		category: 'amenity',
		clpSlug: 'climate-controlled',
		displayName: 'Climate Controlled',
		searchParams: { amenity: 'climate-controlled' },
	},
	'drive-up': {
		category: 'amenity',
		clpSlug: 'drive-up-self-storage',
		displayName: 'Drive Up',
		searchParams: { amenity: 'drive-up-self-storage' },
	},
	electricity: {
		category: 'amenity',
		clpSlug: 'electricity',
		displayName: 'Electricity',
		searchParams: { amenity: 'electricity' },
	},
	mini: {
		category: 'size',
		clpSlug: 'mini-self-storage',
		displayName: 'Mini Storage',
		searchParams: { amenity: 'mini-self-storage' },
	},
	small: {
		category: 'size',
		clpSlug: 'small-self-storage-units',
		displayName: 'Small Storage',
		searchParams: { amenity: 'small-self-storage-units' },
	},
	medium: {
		category: 'size',
		clpSlug: 'medium-self-storage-units',
		displayName: 'Medium Storage',
		searchParams: { amenity: 'medium-self-storage-units' },
	},
	large: {
		category: 'size',
		clpSlug: 'large-self-storage-units',
		displayName: 'Large Storage',
		searchParams: { amenity: 'large-self-storage-units' },
	},
	lockers: {
		category: 'size',
		clpSlug: 'self-storage-lockers',
		displayName: 'Storage Lockers',
		searchParams: { amenity: 'self-storage-lockers' },
	},
	boat: {
		category: 'vehicle',
		clpSlug: 'boat',
		displayName: 'Boat Storage',
		searchParams: { type: 'vehicle', vehicle: 'boat' },
	},
	car: {
		category: 'vehicle',
		clpSlug: 'car',
		displayName: 'Car Storage',
		searchParams: { type: 'vehicle', vehicle: 'car' },
	},
	rv: {
		category: 'vehicle',
		clpSlug: 'rv',
		displayName: 'RV Storage',
		searchParams: { type: 'vehicle', vehicle: 'rv' },
	},
	'free-truck-rental': {
		category: 'amenity',
		clpSlug: 'free-truck-rental',
		displayName: 'Free Truck Rental',
		searchParams: { amenity: 'free-truck-rental' },
	},
	deals: {
		category: 'deals',
		clpSlug: 'deals',
		displayName: 'Storage Deals',
		searchParams: {},
	},
};

export function getKeywordConfig(nmpSlug) {
	return nearMeKeywords[nmpSlug] || null;
}

export function getKeywordsByCategory(category) {
	return Object.keys(nearMeKeywords).filter(
		(slug) => nearMeKeywords[slug].category === category,
	);
}
